import { ArticleType, OnlineProductArticleDetails } from '@nemuru-eng/js-api-client';

import { ProductFormItem } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Product/types/ProductFormItem';
import { Item } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/entities/Item';

export class ProductItem extends Item<ProductFormItem> {
  constructor(data: ProductFormItem) {
    super(data);
  }

  protected isCompleted(): boolean {
    return true;
  }

  protected toForm(): ProductFormItem {
    return {
      ...this.toMinimalFormItem(),
    } as ProductFormItem;
  }

  public static fromOrderLineDto(units: number, article: OnlineProductArticleDetails): ProductItem {
    const formData: ProductFormItem = {
      // Minimal form item fields
      units: units.toString(),
      vat: '21', // FIXME: Default VAT
      price: article.price.amount.toFixed(2).toString(),
      category: article.category,

      // ArticleType-specific fields
      type: ArticleType.ONLINE_PRODUCT,
      description: article.description || '',
    };

    return new ProductItem(formData);
  }

  protected toDto(): object {
    return {};
  }
}
